import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

export function Accordion({ items = [], allowMultiple = false, className = '' }) {
    const [openIds, setOpenIds] = useState([]);

    const toggle = (id) => {
        if (allowMultiple) {
            setOpenIds(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
        } else {
            setOpenIds(prev => prev.includes(id) ? [] : [id]);
        }
    };

    return (
        <div className={`flex flex-col gap-2 ${className}`}>
            {items.map((item) => {
                const isOpen = openIds.includes(item.id);
                return (
                    <div 
                        key={item.id} 
                        className="bg-[var(--bg-surface)] border border-[var(--border)] rounded-xl overflow-hidden transition-colors hover:border-[var(--border-strong)]"
                    >
                        <button
                            onClick={() => toggle(item.id)}
                            className="w-full flex items-center justify-between p-4 text-left cursor-pointer outline-none"
                        >
                            <span className="font-medium text-[var(--text-primary)] text-sm">{item.title}</span>
                            <motion.div
                                animate={{ rotate: isOpen ? 180 : 0 }}
                                transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                                className="text-[var(--text-tertiary)]"
                            >
                                <ObliqueIcon name="expand_more" size={20} />
                            </motion.div>
                        </button>
                        <AnimatePresence initial={false}>
                            {isOpen && (
                                <motion.div
                                    key="content"
                                    initial="collapsed"
                                    animate="open"
                                    exit="collapsed"
                                    variants={{
                                        open: { opacity: 1, height: "auto" },
                                        collapsed: { opacity: 0, height: 0 }
                                    }}
                                    transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                                >
                                    <div className="p-4 pt-0 text-sm text-[var(--text-secondary)]">
                                        {item.content}
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                );
            })}
        </div>
    );
}
